<template>
    <div>
        <el-dialog v-model="aiWaitShow" title="Tips" width="500" :show-close="false" :align-center="true"
            :close-on-click-modal="false">
            <template #header>
                <!-- <div class="header">提示</div> -->
                <div class="close_icon" @click="closePopup">
                    <el-icon :size="20">
                        <CloseBold />
                    </el-icon>
                </div>
            </template>
            <div class="dialog_content">
                <el-image class="ai_wait_bg" :src="imgPath('ai_wait_bg.png')"></el-image>
                <el-image class="ai_wait_scan" :src="imgPath('ai_wait_scan.png')"></el-image>
                <div>试卷正在批阅中，请耐心等待</div>
                <div class="mt-20 wait_text">请耐心等待5~10分钟。也可以返回完成其它测试，稍后再来查看结果。</div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'GjkcH5AiWait',

    data() {
        return {
            aiWaitShow: false,
        };
    },

    mounted() { },

    methods: {
        closePopup() {
            this.aiWaitShow = false;
        },
    },
};
</script>

<style lang="scss" scoped>
:deep(.el-dialog) {
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.06);
    border-radius: 10px;
    padding: 0;
    width: 380px;
    height: 380px;
    position: relative;
}

:deep(.el-dialog__header) {
    position: relative;
    padding: 0 20px;
    box-sizing: border-box;
    text-align: start;
}

.header {
    font-size: 20px;
    color: #333333;
    line-height: 60px;
    border-bottom: 1px solid rgba(36, 35, 36, 0.1);
}

.close_icon {
    position: absolute;
    top: 20px;
    right: 20px;
    color: #333333;
    z-index: 999;
}

.dialog_content {
    position: relative;
    text-align: center;

    .ai_wait_bg {
        width: 380px;
        height: 250px;
    }

    .ai_wait_scan {
        width: 220px;
        height: 200px;
        position: absolute;
        top: 30px;
        left: 80px;
    }

    .wait_text {
        padding: 0 15px;
        font-size: 18px;
        color: #303030;
        line-height: 32px;
    }
}
</style>